function isValidIban(iban) {
    const sanitized = iban.replace(/\s+/g, '').toUpperCase();

    // Basic structural check
    if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(sanitized)) return false;

    // Optional: Validate length per country code
    const ibanLengths = {
        DE: 22,
        GB: 22,
        FR: 27,
        MT: 31,
        NL: 18,
        // ... add others as needed
    };

    const countryCode = sanitized.slice(0, 2);
    const expectedLength = ibanLengths[countryCode];
    if (expectedLength && sanitized.length !== expectedLength) return false;

    // Optional: Validate checksum (MOD-97 algorithm)
    return true;
}
function createYears(next_years = 3) {
    const currentYear = new Date().getFullYear();
    const years = {};

    for (let i = 0; i < next_years; i++) {
        const year = currentYear + i;
        years[year] = String(year);
    }

    return years;
}
export { isValidIban, createYears };